import { useContext } from 'react';

import {
  DisplayConfigContext,
  DisplayConfigProps,
} from './display-config.context.js';

export function useDisplayConfig(): DisplayConfigProps {
  return useContext(DisplayConfigContext);
}
